<template>
  <div class="ppsz-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            名片设置
          </div>
          <div class="card-content" v-loading="loading">
            <el-form ref="eForm" :model="eForm" :rules="eRules" label-width="100px">
              <el-form-item label="品牌名称" prop="name" >
                <el-input v-model="eForm.name" maxlength="20" placeholder="请编辑品牌名称" show-word-limit>
                </el-input>
              </el-form-item>
              <el-form-item label="品牌视频" prop="video">
                <el-upload
                  class="avatar-uploader"
                 :action="uploadFile"
                v-bind:data="{ FoldPath: '上传目录', SecretKey: '安全验证' }"
                v-bind:on-progress="uploadVideoProcess"
                v-bind:on-success="handleVideoSuccess"
                v-bind:before-upload="beforeUploadVideo"
                v-bind:show-file-list="false">
                <video
                  v-if="videoForm.showVideoPath != '' && !videoFlag"
                  v-bind:src="videoForm.showVideoPath"
                class="avatar video-avatar"
                controls="controls">
                您的浏览器不支持视频播放
                </video>
                <i
                  v-else-if="videoForm.showVideoPath == '' && !videoFlag"
                  class="el-icon-plus avatar-uploader-icon"
                  ></i>
                <el-progress
                  v-if="videoFlag == true"
                  type="circle"
                  v-bind:percentage="videoUploadPercent"
                  style="margin-top: 7px"></el-progress>
                </el-upload>
              </el-form-item>
              <el-form-item label="品牌故事" prop="brand_story">
                <tinymce ref="tinymce_brand_story" :key="1" v-model="eForm.brand_story" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item label="品牌理念" prop="brand_idea">
                <tinymce ref="tinymce_brand_idea" :key="2" v-model="eForm.brand_idea" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item label="设计理念" prop="design_idea">
                <tinymce ref="tinymce_design_idea" :key="3" v-model="eForm.design_idea" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item label="产品理念" prop="product_idea">
                <tinymce ref="tinymce_product_idea" :key="4" v-model="eForm.product_idea" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item label="市场定位" prop="agora_position">
                <tinymce ref="tinymce_agora_position" :key="5" v-model="eForm.agora_position" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item label="产品优势" prop="product_merit">
                <tinymce ref="tinymce_product_merit" :key="6" v-model="eForm.product_merit" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item label="色板展示" prop="color_show">
                <tinymce ref="tinymce_color_show" :key="7" v-model="eForm.color_show" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item label="荣誉资质" prop="honor">
                <tinymce ref="tinymce_honor" :key="8" v-model="eForm.honor" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item label="企业简介" prop="company_intro">
                <tinymce ref="tinymce_company_intro" :key="9" v-model="eForm.company_intro" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item label="企业文化" prop="company_culture">
                <tinymce ref="tinymce_company_culture" :key="10" v-model="eForm.company_culture" :height="200" ></tinymce>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="eidtLoading" @click="submitForm('eForm')">修改品牌信息</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import Tinymce from '@/components/Tinymce/index'
import { selectBrandInfoXCX, editBrandInfo, } from '@/api/zsxcx'
export default {
  name: 'ppsz',
  components: { Tinymce },
  computed: {
    user: getUser
  },
  data() {
    return {
      loading: false,
      eidtLoading: false,
      eForm: {
        brandid: 1,
        videoid: null,
        name: null,
        brand_story: null,
        brand_idea: null,
        design_idea: null,
        product_idea: null,
        agora_position: null,
        product_merit: null,
        color_show: null,
        honor: null,
        company_intro: null,
        company_culture: null
      },
      eRules: {
        // img: [{ required: true, message: '请上传形象照', trigger: 'change' }],
        name: [{ required: true, message: '品牌名称不能为空', trigger: 'blur' }],
        brand_story: [{ required: true, message: '品牌故事不能为空', trigger: 'blur' }],
        brand_idea: [{ required: true, message: '品牌理念不能为空', trigger: 'blur' }],
        design_idea: [{ required: true, message: '设计理念不能为空', trigger: 'blur' }],
        product_idea: [{ required: true, message: '产品理念不能为空', trigger: 'blur' }],
        agora_position: [{ required: true, message: '市场定位不能为空', trigger: 'blur' }],
        product_merit: [{ required: true, message: '产品优势不能为空', trigger: 'blur' }],
        color_show: [{ required: true, message: '色板展示不能为空', trigger: 'blur' }],
        honor: [{ required: true, message: '荣誉资质不能为空', trigger: 'blur' }],
        company_intro: [{ required: true, message: '企业简介不能为空', trigger: 'blur' }],
        company_culture: [{ required: true, message: '企业文化不能为空', trigger: 'blur' }]
      },
      uploadFile: process.env.VUE_APP_BASE_API + '/fileUpload/uploadFile',
      headers: '头部',
      videoFlag: false,
      // 是否显示进度条
      videoUploadPercent: '',
      // 进度条的进度，
      isShowUploadVideo: false,
      // 显示上传按钮
      videoForm: {
        // 回显的变量
        showVideoPath: ''
      }
    }
  },
  created() {
    this.selectBrandInfoXCX()
  },
  methods: {
    beforeUploadVideo(file) {
      // 控制大小  修改50的值即可
      // var fileSize = file.size / 1024 / 1024 < 5000
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'video/mov'
          // 控制格式
        ].indexOf(file.type) === -1
      ) {
        this.$message({
          message: '请上传正确的视频格式',
          type: 'error'
        })
        return false
      }
      // if (!fileSize) {
      //   layer.msg('视频大小不能超过50MB')
      //   return false
      // }
      this.isShowUploadVideo = false
    },
    // 进度条
    // 注意在data中添加对应的变量名
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    // 上传成功回调
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true
      this.videoFlag = false
      this.videoUploadPercent = 0
      // 后台上传数据
      if (res.success === true) {
        // 上传成功后端返回视频地址回显
        this.eForm.videoid = res.data.dFileid
        this.videoForm.showVideoPath = res.data.file_url
      } else {
        this.$message.error('上传失败！')
      }
    },
    selectBrandInfoXCX() {
      this.loading = true
      selectBrandInfoXCX().then(response => {
        var row = response.data
        this.eForm.name = row.name
        this.eForm.videoid = row.videoid
        this.videoForm.showVideoPath = row.videoPath
        this.eForm.brand_story = row.brandStory
        this.eForm.brand_idea = row.brandIdea
        this.eForm.design_idea = row.designIdea
        this.eForm.product_idea = row.productIdea
        this.eForm.agora_position = row.agoraPosition
        this.eForm.product_merit = row.productMerit
        this.eForm.color_show = row.colorShow
        this.eForm.honor = row.honor
        this.eForm.company_intro = row.companyIntro
        this.eForm.company_culture = row.companyCulture
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    submitForm(fromName) {
      this.$refs[fromName].validate((valid) => {
        this.eidtLoading = true
        const data = {
          brandid: this.eForm.brandid,
          name: this.eForm.name,
          videoid: this.eForm.videoid,
          brand_story: this.eForm.brand_story,
          brand_idea: this.eForm.brand_idea,
          design_idea: this.eForm.design_idea,
          product_idea: this.eForm.product_idea,
          agora_position: this.eForm.agora_position,
          product_merit: this.eForm.product_merit,
          color_show: this.eForm.color_show,
          honor: this.eForm.honor,
          company_intro: this.eForm.company_intro,
          company_culture: this.eForm.company_culture
        }
        editBrandInfo(data).then(response => {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.selectBrandInfoXCX()
          this.eidtLoading = false
        }).catch(() => {
          this.eidtLoading = false
        })
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9 !important;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px !important;
    position: relative !important;
    overflow: hidden !important;
  }
  .avatar-uploader .el-upload:hover {
    border: 1px dashed #d9d9d9 !important;
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 300px;
    height: 178px;
    display: block;
  }
</style>
